import React, { Component } from 'react'
import AWSAPI from '../../../../common/AWSAPI'
import Config from '../../../../Config'

/*
* これを継承したコンポーネントでは必ずthis.apiUrlをconstructorで設定すること
*/

class CognitoUserManagement extends Component {
  updateCognitoUser (cognitoUser, onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'update',
      username: cognitoUser.id,
      customAttributes: {
        Email: cognitoUser.email,
        Name: cognitoUser.name,
        ParentId: cognitoUser.parentID,
        emailNotification: cognitoUser.emailNotification,
        prefectures: cognitoUser.prefectures,
        branch: cognitoUser.branch,
        administrator: cognitoUser.administrator,
        isMember: cognitoUser.isMember
      }
    }
    // console.log("Request Parameters:", params);
    // console.log("API URL:", this.apiUrl);
    AWSAPI.apiPost('companyAdmin', this.apiUrl, params, (response) => {
        // console.log("API Response:", response);
        onSuccess(response);
    });
  }
  addCognitoUser (cognitoUser, onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'add',
      username: this.uuid(),
      customAttributes: {
        Email: cognitoUser.email,
        Name: cognitoUser.name,
        ParentId: cognitoUser.parentID ? cognitoUser.parentID : '',
        emailNotification: cognitoUser.emailNotification,
        prefectures: cognitoUser.prefectures,
        branch: cognitoUser.branch,
        administrator: cognitoUser.administrator,
        isMember: cognitoUser.isMember
      }
    }
    // console.log("Request Parameters:", params);
    AWSAPI.apiPost('companyAdmin', this.apiUrl, params, (response) => {
        // console.log("API Response:", response);
        onSuccess(response);
    });
  }
  addCognitoUserNoLogin (cognitoUser, onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'add',
      username: this.uuid(),
      customAttributes: {
        Email: cognitoUser.email,
        Name: cognitoUser.name,
        ParentId: cognitoUser.parentID ? cognitoUser.parentID : '',
        emailNotification: cognitoUser.emailNotification,
        prefectures: cognitoUser.prefectures,
        branch: cognitoUser.branch,
        administrator: cognitoUser.administrator,
        isMember: cognitoUser.isMember
      }
    }
    // console.log("Request Parameters:", params);
    AWSAPI.apiPostNoLogin(this.apiUrl, params, (response) => {
        // console.log("API Response:", response);
        onSuccess(response);
    });
  }
  deleteCognitoUser (cognitoUser) {
    const params = {
      userRole: this.userRole,
      command: 'delete',
      username: cognitoUser.id
    }
    AWSAPI.apiPost('companyAdmin', this.apiUrl, params)
  }
  disableCognitoUser (cognitoUser) {
    const params = {
      userRole: this.userRole,
      command: 'disable',
      username: cognitoUser.id
    }
    AWSAPI.apiPost('companyAdmin', this.apiUrl, params)
  }
  enableCognitoUser (cognitoUser) {
    const params = {
      userRole: this.userRole,
      command: 'enable',
      username: cognitoUser.id
    }
    AWSAPI.apiPost('companyAdmin', this.apiUrl, params)
  }
  getCognitoUsers (onSuccess) {
    const params = {
      userRole: this.userRole,
      command: 'list'
    }
    AWSAPI.apiPost('companyAdmin',
      this.apiUrl,
      params,
      (res) => {
        if (res.body && res.body.data && res.body.data.hasOwnProperty('Users')) {
          if (onSuccess) onSuccess(res.body.data.Users)
        }
      }
    )
  }
  getCognitoUser (id, onSuccess, withLogs = false) {
    const params = {
      userRole: this.userRole,
      command: 'get',
      username: id
    }
    AWSAPI.apiPost('companyAdmin',
      this.apiUrl,
      params,
      (res) => {
        if (withLogs) {
          if (onSuccess) onSuccess(res.body.data.userData, res.body.data.logs)
        } else {
          if (onSuccess) onSuccess(res.body.data.userData)
        }
      }
    )
  }
  getAllUsersLoginInfo(onSuccess) {
    this.getCognitoUsers((users) => {
      const usersLoginInfo = [];
      let processedCount = 0;
      if(users.length <= 0) {
        onSuccess(usersLoginInfo);
      }

      users.forEach((user) => {
        this.getCognitoUser(user.Username, (userData, logs) => {
          if (logs && logs.length > 0) {
            usersLoginInfo.push({
              userData: userData,
              logs: logs
            });
          } else {
            usersLoginInfo.push({
              userData: userData,
              logs: []
            });
          }
          processedCount++;

          // すべてのユーザーの処理が完了したらコールバックを呼び出す
          if (processedCount === users.length) {
            if (onSuccess) onSuccess(usersLoginInfo);
          }
        }, true);
      });
    });
  }
  getStatusCaption (code) {
    switch (code) {
      case 'CONFIRMED':
        return 'ログイン済'
      case 'FORCE_CHANGE_PASSWORD':
        return '未ログイン'
      default:
        return code
    }
  }
  getUserDataEmail (email, onSuccess) {
    const params = {
      userRole: 'companyUser',
      command: 'mail',
      email: email,
    }
    // console.log("Request Parameters:", params);
    AWSAPI.apiPost('companyAdmin', this.apiUrl, params, (response) => {
        // console.log("API Response:", response);
        onSuccess(response);
    });
  }
  inheritingEstimationData (baseUserId, baseUserName, basecompanyId, userId, companyId, onSuccess) {
    const params = {
      command: 'inheriting',
      baseUserId: baseUserId,
      baseUserName: baseUserName,
      basecompanyId: basecompanyId,
      userId: userId,
      companyId: companyId,
    }
    // console.log("Request Parameters:", params);
    AWSAPI.apiPost('companyAdmin', this.apiUrl, params, (response) => {
        // console.log("API Response:", response);
        onSuccess(response);
    });
  }
  nl2br (text) {
    if (!(typeof (text) === 'string' || text instanceof String)) return
    const regex = /(\n)/g
    return text.split(regex).map(function (line, index) {
      if (line.match(regex)) {
        return React.createElement('br', { key: index })
      } else {
        return line
      }
    })
  }
  utc2jst (datetime) {
    let dt = new Date(datetime)
    return dt.toLocaleString()
  }
  uuid () {
    let uuid = ''
    let i
    let random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0

      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? ((random & 3) | 8) : random)).toString(16)
    }
    return uuid
  }
  arrayGet (array, name, defaultValue = '') {
    if (array && Array.isArray(array)) {
      const result = array.find((e) => e.Name === name);
      if (result) {
        return result.Value;
      }
    }
    return defaultValue;
  }
}
export default CognitoUserManagement



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/abstract/CognitoUserManagement.js